export default "/images/5c12670a1abb77258914bf325a5f874d.avif";